module.exports = __webpack_public_path__ + "img/educacion.f55b9997.jpg";